"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importDefault(require("react"));
const Select_1 = __importDefault(require("@material-ui/core/Select"));
const core_1 = require("@material-ui/core");
const apollo_boost_1 = require("apollo-boost");
const react_hooks_1 = require("@apollo/react-hooks");
const GET_WAREHOUSES = apollo_boost_1.gql `
query {
  getStoreWarehouses {
    id
    name
  }
}`;
function WarehouseSelector({ warehouseId, setDefaultWarehouseId, setWarehouseId, }) {
    const { loading, data } = react_hooks_1.useQuery(GET_WAREHOUSES);
    if (loading)
        return react_1.default.createElement(react_1.default.Fragment, null, "\u8F09\u5165\u4E2D");
    const storeWarehouses = data.getStoreWarehouses;
    if (warehouseId === undefined) {
        if (storeWarehouses.length === 1) {
            setDefaultWarehouseId(storeWarehouses[0].id);
        }
    }
    let menuItems = storeWarehouses
        .map((e) => react_1.default.createElement(core_1.MenuItem, { key: e.id, value: e.id }, e.name));
    if (menuItems.length > 1) {
        menuItems = [react_1.default.createElement(core_1.MenuItem, { key: "ALL", value: "ALL" }, "\u5168\u90E8"), ...menuItems];
    }
    return (react_1.default.createElement("span", null,
        react_1.default.createElement(Select_1.default, { value: warehouseId === undefined ? 'ALL' : warehouseId, onChange: (e) => {
                if (e.target.value === 'ALL') {
                    setWarehouseId(undefined);
                }
                else {
                    setWarehouseId(e.target.value);
                }
            } }, menuItems)));
}
exports.default = WarehouseSelector;
